<template>
  <section class="hero is-fullheight__without-tables">
    <div class="hero-body">
      <div class="container">
        <div class="columns is-centered">
          <div class="column is-6-tablet is-5-desktop is-4-widescreen">
            <form
              class="lm-forms"
            >
              <div class="level lm-level">
                <div class="level-item has-text-centered">
                  <figure class="image is-128x128">
                    <img :src="loadLogo" />
                  </figure>
                </div>
              </div>
              <div class="level lm-level">
                <div class="level-item has-text-centered lr-title-logo">
                    <span
                      v-t="$t('Common.titleProject')"
                    />
                    <span
                      class="lr-supplier-green"
                      v-t="$t('Common.subTitleProject')"
                    />
                  </div>
              </div>
              <div class="block">
                <b-field
                  class="lm-label"
                  :label="$t('Common.labelEmail')"
                  :type="validateTypeEmail"
                  :message="errorMessageEmail"
                >
                  <b-input
                    class="lm-input"
                    v-model.trim="$v.userData.email.$model"
                    type="email"
                    :disabled="loading"
                  />
                </b-field>
                <b-field
                  class="lm-label"
                  :label="$t('Common.labelPassword')"
                  :type="validateTypePassword"
                  :message="errorMessagePassword"
                >
                  <b-input
                    class="lm-input"
                    v-model.trim="$v.userData.password.$model"
                    type="password"
                    password-reveal
                    :disabled="loading"
                    @keyup.native.enter="save"
                  />
                </b-field>
                <div
                  class="local-lm-link local-lm-xt-margin"
                >
                  <router-link
                    v-t="'Login.forgotPassword'"
                    :to="{ name: 'ForgotPassword' }"
                  />
                </div>
                <b-button
                  v-t="'Common.login'"
                  type="is-success"
                  class="lm-default-btn-green local-lm-xt-margin"
                  :loading="loading"
                  @click.prevent="save"
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { required, minLength, email } from 'vuelidate/lib/validators'
import Logo from '@/assets/img/Movimenta_Supplier_C.svg'
import { mixin } from '@/mixins'

export default {
  name: 'Login',
  mixins: [
    mixin.notifications
  ],
  data () {
    return {
      userData: {
        email: '',
        password: ''
      },
      loading: false
    }
  },
  computed: {
    loadLogo () {
      return Logo
    },
    validateTypeEmail () {
      return !this.$v.userData.email.email
        ? 'is-danger'
        : null
    },
    validateTypePassword () {
      return !this.$v.userData.password.minLength
        ? 'is-danger'
        : null
    },
    errorMessageEmail () {
      return !this.$v.userData.email.email
        ? this.$t('Errors.validEmail')
        : null
    },
    errorMessagePassword  () {
      return !this.$v.userData.password.minLength
        ? this.$t('Errors.passwordLength')
        : null
    }
  },
  methods: {
    async save () {
      this.$v.$touch()
      if (this.$v.$invalid) return false

      this.$store.dispatch('loading/onlyComponent')
      this.loading = true

      const auth = await this.$store.dispatch('user/setAuthorization', this.userData)
      if (!auth.level) {
        this.loading = false
        return this.wrong(this.$t('Errors.somethingWrong'))
      }

      this.$store.dispatch('loading/fullScreen')
      this.$router.push({ name: 'Orders' })
    }
  },
  validations: {
    userData: {
      email: {
        required,
        email,
        minLength: minLength(8)
      },
      password: {
        required,
        minLength: minLength(8)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Login.vue